import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import CopyToClipboard from 'Pods/Shared/CopyTextOnClick'
import SocialButtons from 'Pods/Shared/SocialButtons'

function SuccessPage({ url, approved }) {
  function flashSuccess(e) {
    e.preventDefault()
    App.events.publish('app:notification:flash:success', 'Your link has been copied!')
  }

  return (
    <div className="project-success-screen">
      <div className="card card--flat">
        <div className="success-screen__header">
          <Icon type={['fal', 'check-circle']} size="5x" color="green-dark" />
          <h2 className="heading-40">Congratulations!</h2>
          <h3 className="heading-18">Your Project was created successfully</h3>
        </div>

        <div class="success-screen__review_notice" style={{ display: approved ? 'none' : 'block' }}>
          <p>
            Your application is undergoing a manual review to ensure project legitimacy
            and website security. <br />
            The review may take up 3 business days. Thank you for your understanding.
          </p>
        </div>

        <p className="success-screen__heading">Share it to attract more applicants:</p>

        <SocialButtons
          socialNetworks={['facebook', 'linkedin', 'twitter']}
          page="Footer"
          className="social-icon-circle--xlarge social-icon-circle--outline"
          url={url}
          share
        />

        <p className="success-screen__heading">Or copy the link below</p>

        <div className="form-inline form-group form-group-grey">
          <input className="form-control form-control-grey u-mr10" type="text" name="shareable-url" defaultValue={url} />

          <CopyToClipboard text={url} id="copy-shareable-link">
            <button className="btn btn-primary" onClick={flashSuccess}>Copy</button>
          </CopyToClipboard>
        </div>
      </div>

      <div className="u-text-center">
        <a href="/profile/projects" className="btn btn-primary">Go to Projects dashboard</a>
      </div>
    </div>
  )
}

SuccessPage.propTypes = {
  url: PropTypes.string.isRequired,
}

export default SuccessPage
